import http from "@/libs/http";
const club = {
  /**审批俱乐部- 系统管理员、青少司 */
  clubApprove: ApproveVO => {
    return http.post(http.formatUrl("club/approve"), ApproveVO);
  },
  /**批量审批俱乐部- 系统管理员、青少司 */
  clubApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("club/approve/batch"), BatchApproveVO);
  },
  /**删除俱乐部- 系统管理员、项目中心*/
  clubDelete: ClubId => {
    return http.post(http.formatUrl("club/delete"), ClubId);
  },
  /**查看俱乐部- 系统管理员、项目中心、青少司*/
  clubInfo: ClubId => {
    return http.get(http.formatUrl("club/info"), ClubId);
  },
  /**新建俱乐部- 系统管理员、项目中心*/
  clubInsert: ClubVO => {
    return http.post(http.formatUrl("club/insert"), ClubVO);
  },
  /**查询俱乐部分页列表 - 系统管理员 、项目中心 、青少司*/
  clubPagelist: ClubPageListVO => {
    return http.get(http.formatUrl("club/pagelist"), ClubPageListVO);
  },
  /**撤销已提交的俱乐部- 系统管理员、项目中心*/
  clubRevoke: ClubId => {
    return http.post(http.formatUrl("club/revoke"), ClubId);
  },
  /**提交俱乐部- 系统管理员、项目中心*/
  clubSubmit: ClubId => {
    return http.post(http.formatUrl("club/submit"), ClubId);
  },
  /**批量提交俱乐部- 系统管理员、项目中心*/
  clubSubmitBatch: BatchClubId => {
    return http.post(http.formatUrl("club/submit/batch"), BatchClubId);
  },
  /**更新俱乐部- 系统管理员、项目中心*/
  clubUpdate: ClubVO => {
    return http.post(http.formatUrl("club/update"), ClubVO);
  }
};
export default club;
